import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { AllocationViewEndpoint } from '../../constants/allocation-view-endpoint';
import { UliDetailsPreviewCriteria, UliDetailsPreviewModel } from '../models/uli-details.model';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { RequestHeader } from '../../../../../constants';

@Injectable({
  providedIn: 'root',
})
export class UliDetailsService {
  constructor(private http: WrapperHttpService) {}

  public getUliDetails(criteria: UliDetailsPreviewCriteria, hubId: number): Observable<UliDetailsPreviewModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Uli}${AllocationViewEndpoint.Details}${
      AllocationViewEndpoint.Preview
    }?${getQueryStringFromObject(criteria)}`;
    const headers = new HttpHeaders({ [RequestHeader.IntrackHubId]: hubId.toString() });

    return this.http.get<UliDetailsPreviewModel>(url, { headers });
  }
}
